import { render, staticRenderFns } from "./NotificacaoFormulario.vue?vue&type=template&id=c313b06c&scoped=true"
import script from "./NotificacaoFormulario.vue?vue&type=script&lang=js"
export * from "./NotificacaoFormulario.vue?vue&type=script&lang=js"
import style0 from "./NotificacaoFormulario.vue?vue&type=style&index=0&id=c313b06c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c313b06c",
  null
  
)

export default component.exports